var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_2634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 10.14C19.23 10.14 17.5 9.58995 16.07 8.55995V15.74C16.0698 17.0695 15.6638 18.3672 14.9063 19.4598C14.1487 20.5524 13.0757 21.3877 11.8307 21.8541C10.5856 22.3204 9.2279 22.3957 7.93897 22.0697C6.65003 21.7437 5.49131 21.0321 4.61769 20.0299C3.74406 19.0277 3.19716 17.7827 3.05009 16.4614C2.90302 15.14 3.16279 13.8052 3.79467 12.6355C4.42655 11.4657 5.40044 10.5167 6.58616 9.91531C7.77187 9.3139 9.11291 9.08875 10.43 9.26995V12.88C9.82674 12.6902 9.17894 12.696 8.57915 12.8964C7.97935 13.0969 7.45824 13.4818 7.09024 13.9961C6.72224 14.5104 6.52619 15.1278 6.53007 15.7602C6.53396 16.3926 6.73759 17.0076 7.11188 17.5173C7.48617 18.0271 8.01197 18.4055 8.61418 18.5986C9.21639 18.7916 9.86422 18.7894 10.4651 18.5923C11.066 18.3952 11.5892 18.0132 11.9601 17.501C12.3309 16.9887 12.5304 16.3724 12.53 15.74V1.69995H16.07C16.0633 2.34876 16.1863 2.99238 16.4318 3.59299C16.6773 4.1936 17.0404 4.73909 17.4996 5.19743C17.9589 5.65577 18.5051 6.01771 19.1062 6.26199C19.7074 6.50628 20.3512 6.62798 21 6.61995V10.14Z",
    fill: "#FFFDFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_2634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.745b84227c2c919f6b472a1f9fa1edc0.svg";
export { ForwardRef as ReactComponent };